module.exports = __webpack_public_path__ + "static/media/02.709d1541.png";